<button
  class="btn btn-debug btn-block"
  (click)="open()"
  appAnalyticsClick="Meta:Icons"
  appSfx="ui-click"
  [sfxOffset]="4"
  [sfxTrigger]="['click', 'hover']"
>
  Game Icon Library
</button>
